"use client";

import {
  InlineNotification,
  RadioButton,
  RadioButtonGroup,
  TextArea,
  TextInput,
} from "@carbon/react";
import { useActionState } from "react";
import {
  submitWaitlistAction,
  type WaitlistState,
} from "@/app/waitlist-actions";
import { FormShell } from "@/components/FormShell";
import { waitlistCopy } from "@/lib/ui/landing";

const initialState: WaitlistState = { error: null, message: null };

export function WaitlistForm() {
  const [state, formAction, pending] = useActionState(
    submitWaitlistAction,
    initialState,
  );

  if (state.message) {
    return (
      <InlineNotification
        kind="success"
        title="Заявка"
        subtitle={state.message}
        hideCloseButton
        lowContrast
      />
    );
  }

  return (
    <FormShell
      layout="plain"
      className="landing-form"
      action={formAction}
      error={state.error}
      errorTitle="Заявка"
      submitLabel={waitlistCopy.submit}
      pendingLabel={waitlistCopy.pending}
      pending={pending}
      submitKind="primary"
      submitSize="md"
    >
      <div className="landing-form-grid">
        <TextInput
          id="waitlist-name"
          name="name"
          labelText={waitlistCopy.nameLabel}
          autoComplete="name"
          required
        />
        <TextInput
          id="waitlist-email"
          name="email"
          type="email"
          labelText={waitlistCopy.emailLabel}
          autoComplete="email"
          required
        />
      </div>
      <TextInput
        id="waitlist-company"
        name="company"
        labelText={waitlistCopy.companyLabel}
        autoComplete="organization"
        required
      />
      <RadioButtonGroup
        legendText={waitlistCopy.deploymentLabel}
        name="deployment"
        defaultSelected="CLOUD"
        orientation="horizontal"
      >
        <RadioButton id="waitlist-cloud" labelText={waitlistCopy.cloud} value="CLOUD" />
        <RadioButton
          id="waitlist-onprem"
          labelText={waitlistCopy.onprem}
          value="ONPREM"
        />
      </RadioButtonGroup>
      <TextArea
        id="waitlist-comment"
        name="comment"
        labelText={waitlistCopy.commentLabel}
        helperText={waitlistCopy.commentHint}
        rows={3}
      />
    </FormShell>
  );
}
